import {
    DeleteOutlined,
    EditOutlined,
    FileTextOutlined,
} from '@ant-design/icons'
import { Button, Card, Divider, List, Tooltip, Typography } from 'antd'
import StackCompletionBar from './StackCompletionBar'
import ShowFilter from './ShowFilter'
import styles from '../../../testrun.module.css'
import { fDate } from '../../../utils/helpers'

const TestRunItem = (props) => {
    const { item, onDeleteRequest, onEdit, percents } = props
    const note = (item?.note || item?.notes || '').trim()

    return (
        <List.Item className={styles.listItem}>
            <Card className={styles.reportCard} bordered>
                <div className={styles.reportCardInner}>
                    <div className={styles.reportCardMain}>
                        <div className={styles.reportCardContent}>
                            <Typography.Text
                                ellipsis={{ tooltip: item?.name }}
                                className={styles.reportCardName}
                            >
                                {item?.name}
                            </Typography.Text>

                            <div className={styles.reportCardMeta}>
                                <span>
                                    By {item?.createdBy?.name || 'Unknown'} on{' '}
                                    {fDate(item?.createdAt)}
                                </span>
                                <Divider
                                    type="vertical"
                                    className={styles.reportCardMetaDivider}
                                />
                                <Typography.Link
                                    className={styles.editLink}
                                    onClick={() => onEdit(item?._id)}
                                >
                                    <EditOutlined style={{ marginRight: 4 }} />
                                    Edit
                                </Typography.Link>
                            </div>

                            <span className={styles.reportCardStats}>
                                {item?.passed} Passed · {item?.pending} Pending
                                · {item?.retest} Retest · {item?.failed} Failed
                            </span>

                            <span className={styles.reportCardFilters}>
                                Group by:{' '}
                                <ShowFilter data={item?.filters || {}} />
                            </span>

                            <span className={styles.reportCardNote}>
                                <FileTextOutlined
                                    className={styles.reportCardNoteIcon}
                                />
                                Notes:{' '}
                                {note ? (
                                    <Tooltip title={note}>
                                        <span
                                            className={styles.reportCardNoteText}
                                        >
                                            {note}
                                        </span>
                                    </Tooltip>
                                ) : (
                                    <span
                                        className={styles.reportCardNoteEmpty}
                                    >
                                        No notes added
                                    </span>
                                )}
                            </span>
                        </div>
                    </div>

                    <div className={styles.reportCardSide}>
                        <div className={styles.progressWrap}>
                            <div className={styles.progressBar}>
                                <StackCompletionBar
                                    percents={percents}
                                    height={14}
                                />
                            </div>
                            <span className={styles.progressPct}>
                                {Math.round(percents.completed)}%
                            </span>
                        </div>

                        <Tooltip title="Delete" placement="bottom">
                            <Button
                                type="text"
                                className={styles.deleteBtn}
                                icon={<DeleteOutlined />}
                                aria-label="Delete"
                                onClick={() => onDeleteRequest(item?._id)}
                            />
                        </Tooltip>
                    </div>
                </div>
            </Card>
        </List.Item>
    )
}

export default TestRunItem
